import { useEffect, useState } from 'react';

import { useTranslation } from '../../../core/context/TranslationContext';

import { getSpending } from '../api/budget';
import { endOfMonth, startOfMonthsAgo, toLocalIso } from './spendingFormat';

/**
 * Loads the combined spending report (card charges + receipts, each purchase
 * once) for a month range and scope. Defaults to the last 12 months, mine.
 */
export default function useSpendingReport() {
  const { t } = useTranslation();
  const [range, setRange] = useState(() => ({
    from: startOfMonthsAgo(11),
    to: endOfMonth(new Date()),
  }));
  const [scope, setScope] = useState('mine');
  const [report, setReport] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getSpending(toLocalIso(range.from), toLocalIso(range.to), scope);
        if (!cancelled) setReport(data);
      } catch (err) {
        console.error('Failed to load spending report', err);
        if (!cancelled) setError(err?.message || t('error'));
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [range, scope, t]);

  const changeRange = ({ start, end }) => {
    setRange((prev) => ({
      from: start ? new Date(start.getFullYear(), start.getMonth(), 1) : prev.from,
      to: end ? endOfMonth(end) : prev.to,
    }));
  };

  return { range, changeRange, scope, setScope, report, loading, error };
}
